export default "__VITE_ASSET__B$hhEu0s__"